module.exports = __webpack_public_path__ + "static/1-74045dc90d4e17cebd273b634185ae79.png";